import { NgModule } from '@angular/core';
import { GlobalLayoutComponent } from './global-layout.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { CoreModule } from '@app/core/core.module';
import { AlertsMenuComponent } from './components/alerts-menu/alerts-menu.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { SettingsComponent } from './components/settings/settings.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NavigationItemComponent } from './components/navigation-item/navigation-item.component';
import { PackhouseConnectivityComponent } from './components/packhouse-connectivity/packhouse-connectivity.component';

@NgModule({
  imports: [CommonModule, RouterModule, CoreModule],
  declarations: [
    GlobalLayoutComponent,
    ProfileMenuComponent,
    AlertsMenuComponent,
    NavigationComponent,
    SettingsComponent,
    NotificationsComponent,
    NavigationItemComponent,
    PackhouseConnectivityComponent,
  ],
  exports: [GlobalLayoutComponent],
})
export class GlobalLayoutModule {}
